/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmContractAbiRequest = {
    contractAddress: string;
    abiRwType?: EvmContractAbiRequest.abiRwType;
};

export namespace EvmContractAbiRequest {

    export enum abiRwType {
        READ = 'READ',
        WRITE = 'WRITE',
        NONE = 'NONE',
        ALL = 'ALL',
    }


}

